var map = {
	"./companies/customers/config/router.customers.js": "8399",
	"./companies/manufacturers/config/router.manufacturers.js": "78cc",
	"./companies/shipping_carriers/config/router.shipping_carriers.js": "a4e4",
	"./companies/vendors/config/router.vendors.js": "77c3",
	"./configuration/active_sessions/config/router.active_sessions.js": "5bf6",
	"./configuration/bank_accounts/config/router.bank_accounts.js": "02fbc",
	"./configuration/chart_of_accounts/config/router.chart_of_accounts.js": "1ce8",
	"./configuration/configuration_menu/config/router.settings.js": "c8d5",
	"./configuration/currencies/config/router.currencies.js": "5fab",
	"./configuration/currencies/config/router.exchange_rates.js": "65b1",
	"./configuration/dashboard_widgets/config/router.dashboard_widgets.js": "e3ea",
	"./configuration/data_import_logs/config/router.data_import_logs.js": "2b89",
	"./configuration/departments/config/router.departments.js": "880e",
	"./configuration/developer/config/router.forms.js": "3083",
	"./configuration/developer/config/router.sql.js": "33ea",
	"./configuration/environment/config/router.environment.js": "1d07",
	"./configuration/help_articles/config/router.help_articles.js": "6f8e",
	"./configuration/languages/config/router.languages.js": "bccb",
	"./configuration/login_attempts/config/router.login_attempts.js": "6ff6",
	"./configuration/notifications/config/router.notifications.js": "9e9b",
	"./configuration/options/config/router.options_categories.js": "86ca",
	"./configuration/payment_terms/config/router.payment_terms.js": "fb3a",
	"./configuration/permissions/config/router.permissions.js": "8cb3",
	"./configuration/units_of_measure/config/router.units_of_measure.js": "5177",
	"./configuration/user_defined_fields/config/router.user_defined_fields.js": "7f84",
	"./people/config/router.people.js": "d70c",
	"./users/config/router.users.js": "4922"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c79";